import { IDataField } from '@/models'
import { DATA_FIELD_ROLE } from '@/enums'

export function setDataField(
    fields: IDataField[],
    fieldRole: DATA_FIELD_ROLE,
    fieldValue: string,
    options?: { silent?: boolean }
): void {
    const field = fields.find(field => field.role === fieldRole)

    if (field) {
        field.value = fieldValue
    } else {
        if (!options?.silent) throw new Error(`Field with role ${fieldRole} does not exist`)
    }
}
